import React from 'react';

import { Box, Dialog } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import styles from './styles';

const useStyles = makeStyles(createStyles(styles));

const ExpressionDialog = ({ open = false, expressionImage = '', onClose = () => {}, children, ...props }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ square: true }}
      classes={{ paper: classes.dialogPaper }}
      {...props}
    >
      {expressionImage && (
        <Box className={classes.expressionBox}>
          <img src={expressionImage} alt="expression" />
        </Box>
      )}
      {children}
    </Dialog>
  );
};

export default ExpressionDialog;
